<!-- 我的金币 我的积分统计 -->

<template>
<div>
    <ul class="media-banner-menu">
        <li class="info"><div class="box" @click="lookCurrencyDetail">
            <div class="cont ico"><img :src="require('../assets/my-coin-gold.png')" alt=""></div>
            <div class="title"><img :src="require('../assets/my-coin-shadow.png')" /></div>

            <div class="total-num" v-if="isLogin">{{coin}}</div>
            <div class="flex-cont" v-if="isLogin"></div>
            <!-- <div class="flex-cont">
                <div class="no-login" v-else>登录</div>
            </div> -->
            <div class="look-detail" v-if="isLogin">查看明细 &gt;</div>
            <div class="no-login" v-if="!isLogin">登录账号，立即下注</div>
            
        </div></li>
        <li class="info guessing"><div class="box" @click="lookGuessingDetail" >
            <div class="cont ico"><img :src="require('../assets/my-coin-ball.png')" alt=""></div>
            <div class="title"><img :src="require('../assets/my-guessing-shadow.png')" /></div>
            <div class="total-num" v-if="isLogin">下注{{count}}次</div>
            <div class="flex-cont" v-if="isLogin">
                
            </div>
            <div class="look-detail" v-if="isLogin">查看明细 &gt;</div>
            <div class="no-login" v-if="!isLogin">登录账号，立即下注</div>
            
        </div></li>
        <li class="schedule"><a href="/fifaschedule" target="_blank" class="box ">
            <div class="cont ico"><img :src="require('../assets/schedule.png')" alt=""></div>
            <div class="title"><img :src="require('../assets/saichengbiao.png')" /></div>
            <div class="flex-cont"></div>
            <div class="look-detail">点击查看 &gt;</div>
        </a></li>
        <li class="schedule"><a href="https://forum.yorkbbs.ca/detail/c77247b0-9910-412d-989b-1c6723f85a33?topic=chat" target="_blank" class="box schedule">
            <div class="cont ico"><img :src="require('../assets/note.png')" alt=""></div>
            <div class="title"><img :src="require('../assets/game-rules.png')" /></div>
            <div class="flex-cont"></div>
            <div class="look-detail">点击查看 &gt;</div>
        </a></li>
        
    </ul>
    <ul class="media-banner-menu phone ">
        <li class="info"><div class="box" @click="lookCurrencyDetail">         
            <div class="title" v-if="isLogin"><img :src="require('../assets/my-coin-shadow.png')" /></div>
            <div class="total-num" v-if="isLogin">{{coin}}</div>
           
            <div class="no-login" v-if="!isLogin">登录账号，立即下注</div>
            
        </div></li>
        <li class="info guessing"><div class="box" @click="lookGuessingDetail" >
            
             <div class="title" v-if="isLogin"><img :src="require('../assets/my-guessing-shadow.png')" /></div>
            <div class="no-login" v-if="!isLogin">登录账号</div>
            
        </div></li>
        <li class="schedule"><a href="/fifaschedule" target="_blank" class="box ">
            
            <div class="title"><img :src="require('../assets/saichengbiao.png')" /></div>
           
        </a></li>
        <li class="schedule"><a href="https://forum.yorkbbs.ca/detail/c77247b0-9910-412d-989b-1c6723f85a33?topic=chat" target="_blank" class="box schedule">
       
            <div class="title"><img :src="require('../assets/game-rules.png')" /></div>
            
        </a></li>
        
    </ul>
    <MyGameMoney :status.sync="gameMoneyStatus" />
    <MyGuessing :status.sync="myGuessingStatus" />
</div>
</template>
<script>
import { hostBuild } from '@/utils/utils';
import MyGameMoney from '../dialog/my-game-money.vue'
import MyGuessing from '../dialog/my-guessing.vue'

export default {
    name:'MyMoneyInfo',
    components:{MyGameMoney,MyGuessing},
    computed:{
        isLogin(){
            return this.$store.getters.isLogin;
            //return false;
        }
    },
    data(){
        return {
            gameMoneyStatus:false,
            myGuessingStatus:false,
            coin:0,
            count:0,
        }
    },
    created(){
        if( this.isLogin){
            this.getUserRecord();
        }
    },
    methods:{
        lookCurrencyDetail(){
            if(this.isLogin){
                this.gameMoneyStatus = true;
            }else{
                let path ='/login?redirect=' + encodeURIComponent(window.location.href);
                window.location.href = hostBuild(path,'account');
            }
        },
        lookGuessingDetail(){
            console.log('是不是点击了')
            if(this.isLogin){
                this.myGuessingStatus = true;
            }else{
                let path ='/login?redirect=' + encodeURIComponent(window.location.href);
                window.location.href = hostBuild(path,'account');
            }
        },
        async getUserRecord(){
            this.pageLoading = true;
            let result = await this.$axios.get('/worldcup2022/game/coin/my/user/info')
            this.pageLoading = false;
            if( result.code == 0 ){
                this.coin = result.data.coin;
                this.count = result.data.count;
                this.$store.dispatch('userAddProperty',{coin:result.data.coin})
            }
            console.log('用户战绩',result)
        }
        
    },
    watch:{
        isLogin(value){
            if(value){
                this.getUserRecord();
            }
        }
    }

}
</script>
<style lang="less" scoped>
.media-banner-menu{
    display: flex; align-items: center; margin:30px -5px 40px;
    &.phone{display: none;}
    li{
        padding: 0 5px;
        .box{
            display: flex; align-items: center; user-select: none; cursor: pointer;
            height: 50px; padding: 0 15px; border-radius: 10px;
            .ico{
                margin-right: 5px;
                img{display: block; height: 26px;}
            }
            .flex-cont{flex:1; overflow: hidden;}
            .title{ margin-right: 5px;
                img{height: 18px;}
            }
            .look-detail{font-size: 14px; line-height: 20px;}
            .total-num{font-size: 16px; line-height: 20px; color: #111;}
            .no-login{font-size: 14px; line-height: 20px; color: #CD1E00;}
            &:hover{
                .look-detail{text-decoration: underline;}
            }
        }
        &.info{
            flex:8;
            .box{
                background: linear-gradient(0deg,#e9c666, #ffe492 66%, #ffedaf);
                box-shadow: 0px 1px 4px 0px #dab653 inset, 0 5px 0px #B4912D; 
                .title{color: #614800; text-shadow: 1px 0 1px #FFF6C4, 0 1px 1px #FFF6C4,0 -1px 1px #FFF6C4,-1px 0 1px #FFF6C4;}
                .look-detail{color: #926A1E;}
            }
        }
        
        &.schedule{
            flex:5;
            .box{
                background:  linear-gradient(0deg,#fc7703, #ffb607);
                box-shadow: 0 5px 0px #833200;
                .title{
                    img{height: 15px;}
                }
                .look-detail{color: #fff;}
            }
        }
    }
}
@media screen and (max-width:768px){
    .media-banner-menu{
        display: none;
        &.phone{
            display: flex; margin-top: 10px; margin-bottom: 15px ;
            li{
                flex:5;
                .box{
                    padding: 0; justify-content: center;
                    .title{font-size: 12px; line-height: 12px;}
                    .total-num{font-size: 12px; line-height-step: 12px;}
                }
                &:first-child{flex:9}
                &.schedule{
                    .box{
                        .title{margin-right: 0;}
                    }
                }
                &.guessing{
                    .box{
                        .title{margin-right: 0;}
                    }
                }
            }
        }
       
        /* li{
            .box{
                padding: 0; justify-content: center;
                .flex-cont{display: none;}
                .ico{display: none;}
                .look-detail{display: none;}
                .title{font-size: 12px; line-height: 12px;}
                .total-num{font-size: 12px; line-height-step: 12px;}
            }
            &.guessing{
                .box{
                    .total-num{display: none;}
                }
            }
            &.schedule{
                .box{
                    .title{margin-right: 0;}
                }
            }
        } */
    }
}
</style>